import * as localForage from 'localforage';

const isEmpty = (obj) => {
  return (
    obj === undefined ||
    obj === null ||
    (typeof obj === 'object' && Object.keys(obj).length === 0) ||
    (Array.isArray(obj) && obj.length === 0) ||
    (typeof obj === 'string' && obj.trim().length === 0)
  );
};

const settings: { forage: any } = {
  forage: {
    storeName: 'BluInTouch',
    name: 'BluInTouch Application Storage',
    version: 1,
    description: 'Storage for BluInTouch',
  },
};

const configureForage = () => {
  localForage.config(settings.forage);

  return localForage;
};

/**
 * createNewStore
 *
 * create new database and/or store
 * @param config { storeName: string, name: string, version: number, description: string }
 * @returns {Promise<any>}
 */
const createNewStore = (config) => {
  return localForage.createInstance(config);
};

/**
 * localGet
 *
 * get data from local storage based on 'key'
 * @param key
 * @returns {Promise<any>}
 */
const localGet = (key) => {
  return localForage.getItem(key);
};

/**
 * localSet
 *
 * set data in local storage based on 'key'
 * @param {{key: string; data: any}} obj
 * @returns {Promise<any>}
 */
const localUpdate = async (obj) => {
  if (obj && obj.key) {
    const currentData = await localForage.getItem(obj.key);
    let newData;

    if (Array.isArray(obj.data)) {
      newData = [...currentData, ...obj.data];
    } else if (!isEmpty(currentData) && !isEmpty(obj.data)) {
      newData = { ...currentData, ...obj.data };
    } else {
      newData = obj.data;
    }

    return localForage.setItem(obj.key, newData);
  }
};

/**
 * localSet
 *
 * set data in local storage based on 'key'
 * @param {{key: string; data: any}} obj
 * @returns {Promise<any>}
 */
const localSet = (obj) => {
  if (obj && obj.key) {
    return localForage.setItem(obj.key, obj.data);
  }
};

/**
 * localRemove
 *
 * delete data from local storage based on 'key'
 * @param {string[]} keys
 * @returns {any}
 */
const localRemove = (keys) => {
  return Promise.all(keys.map((key) => localForage.removeItem(key)));
};

/**
 * localClear
 *
 * clear storage
 * @returns {Promise<void>}
 */
const localClear = () => {
  return localForage.clear();
};

export {
  localGet,
  localSet,
  localUpdate,
  localRemove,
  localClear,
  configureForage,
  createNewStore,
};
